<template>
  <v-container
    id="accountDetails"
    fluid
    tag="section"
    v-resize="onResize"
  >
    <acct-staff-toolbar
      page="staff"
    ></acct-staff-toolbar>
    <base-tile-card
      color="#4242C7"
      flat
      class="pt-n5"
    >
      <template v-slot:heading>
        <v-tabs
          v-model="tab"
          background-color="#4242C7"
          dark
          show-arrows
          class="tile-card-heading"
        >
          <v-tab
            key="summary"
          >
            Summary
          </v-tab>
          <v-tab
            key="billing"
          >
            Billing
          </v-tab>
          <v-tab
            key="contact"
          >
            Contact Info
          </v-tab>
          <v-tab
            key="payment"
          >
            Payment
          </v-tab>
          <v-tab
            key="activity"
          >
            Account Activity
          </v-tab>
        </v-tabs>
      </template>
      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item
          key="summary"
        >
          <v-row
            dense
            class="d-flex"
          >
 <!--            General-->
            <base-sq-card
              title="General"
            >
              <pow-account-general></pow-account-general>
            </base-sq-card>
<!--            Service Location-->
            <base-sq-card
              style="width: 300px"
            >
              <template v-slot:heading>
                <span class="tile-card-heading">Service Location</span>
              </template>
              <v-row class="mx-1">
                <v-list
                  v-if="selectedAccount._addresses && selectedAccount._addresses.service"
                  dense
                >
                  <v-list-item>
                    <v-list-item-content
                      class="list-lbl"
                    >
                      Address
                    </v-list-item-content>
                    <v-list-item-content>
                      {{ selectedAccount._addresses.service.addr1 }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content
                      class="list-lbl"
                    >
                      City
                    </v-list-item-content>
                    <v-list-item-content>
                      {{ selectedAccount._addresses.service.city }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content
                      class="list-lbl"
                    >
                      State
                    </v-list-item-content>
                    <v-list-item-content>
                      {{ selectedAccount._addresses.service.state }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-row>
            </base-sq-card>
<!--            Tickets-->
            <base-sq-card
              style="width: 500px"
            >
              <template v-slot:heading>
                <span class="tile-card-heading">Tickets</span>
              </template>
              <pow-account-tickets></pow-account-tickets>
            </base-sq-card>
<!--            Forms-->
            <base-sq-card
              style="width: 500px"
            >
              <template v-slot:heading>
                <span class="tile-card-heading">Forms</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      elevation="2"
                      fab
                      absolute
                      small
                      bottom
                      right
                      v-bind="attrs"
                      v-on="on"
                      @click="dlgAssignForm = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Assign a form to the account to be signed or completed</span>
                </v-tooltip>
              </template>
              <pow-account-forms></pow-account-forms>
            </base-sq-card>
<!--           Assign Forms Modal-->
            <v-dialog
              v-model="dlgAssignForm"
              max-width="600px"
            >
              <base-tile-card>
                <template v-slot:heading>
                  Assign Forms
                </template>
                <v-row>
                  <pow-account-assign-forms></pow-account-assign-forms>
                </v-row>
              </base-tile-card>
            </v-dialog>
<!--            Plans-->
            <acct-plans></acct-plans>
<!--            Users-->
            <base-sq-card
              style="width: 500px"
            >
              <template v-slot:heading>
                <span class="tile-card-heading">Users</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      elevation="2"
                      fab
                      absolute
                      small
                      bottom
                      right
                      v-bind="attrs"
                      v-on="on"
                      @click="dlgAddLogin = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Assign a login to this account</span>
                </v-tooltip>
              </template>
              <pow-account-users></pow-account-users>
<!--           Assign User/login Modal-->
              <v-dialog
                v-model="dlgAddLogin"
                max-width="600px"
                persistent
              >
                <acct-assign-login
                  @closeForm="dlgAddLogin = false"
                  @loginAdded="getUsers"
                ></acct-assign-login>
              </v-dialog>
<!--              End Dialog-->
            </base-sq-card>
<!--            Correspondences-->
            <acct-correspondences></acct-correspondences>
          </v-row>
        </v-tab-item>
        <v-tab-item
          key="billing"
        >
          <v-row
            class="d-flex fluid"
          >
            <!--            Invoices-->
            <v-col
              class="d-flex"
            >
              <acct-invoices></acct-invoices>
            </v-col>
            <!--            Payments-->
            <v-col>
              <pow-account-payments></pow-account-payments>
            </v-col>
            <v-col>
              <base-sq-card
                title="Statement/Payment Method"
              >
                <v-col
                  cols="12"
                  class="px-0"
                >
                  <v-radio-group
                    v-model="selectedAccount._statementMethod"
                    @change="onStatementMethodChange"
                  >
                    <v-radio
                      value="CREDIT CARD"
                    >
                      <template v-slot:label>
                        <div class="lbl-radio">Autopay on the first of every month via <strong>[Credit Card]</strong></div>
                      </template>
                    </v-radio>
                    <v-radio
                      value="ECHECK"
                    >
                      <template v-slot:label>
                        <div class="lbl-radio">Autopay on the first of every month via <strong>[eCheck]</strong></div>
                      </template>
                    </v-radio>
                    <v-radio
                      value="EMAIL"
                    >
                      <template v-slot:label>
                        <div class="lbl-radio">Statements <strong>emailed</strong> on the 12th</div>
                      </template>
                    </v-radio>
                    <v-radio
                      value="PAPER"
                      disabled
                    >
                      <template v-slot:label>
                        <div
                          class="lbl-radio"
                          style="display: block"
                        >
                          Statements <strong>mailed</strong> after the 12th &nbsp;
                        </div>
                        <div
                          style="display: block"
                          class="ml-2"
                        >
                          An additional $3.49 fee for mailed statements. Please call if you would like this added.
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <v-card
                    flat
                    class="px-3 pb-3 mx-3 card-full-width"
                    v-if="updateStatementErrors.length > 0"
                  >
                    <v-alert
                      type="error"
                    >
                      <ul>
                        <li
                          v-for="(err, i) in updateStatementErrors"
                          :key="i"
                        >
                          {{ err }}
                        </li>
                      </ul>
                    </v-alert>
                  </v-card>

                  <v-card
                    flat
                    class="mx-auto card-full-width"
                  >
                    <v-btn
                      v-if="statementMethodChanged"
                      tile
                      color="primary"
                      @click="doUpdateStatementMethod"
                      :loading="acctIsUpdatingPaymentDetails"
                      :disabled="acctIsUpdatingPaymentDetails"
                    >
                      Update Statement Method
                    </v-btn>
                  </v-card>
                </v-col>

              </base-sq-card>
            </v-col>
          </v-row>
          <v-row
            class="d-flex"
          >
            <!--                Credit Card Details-->
            <v-col
              cols="12"
              md="6"
            >
              <base-sq-card
                title="Credit Card"
              >
                <v-row
                  class="d-flex flex-column mx-2"
                >
                  <v-card
                    flat
                    class="px-3 pb-3 mx-3 card-full-width"
                  >
                    <v-form
                      ref="formCreditCard"
                    >
                      <v-row>
                        <v-col
                          md="4"
                          cols="12"
                        >
                          <v-radio-group
                            v-model="selectedAccount._ccInfo.cctype"
                            :rules="[rules.required]"
                          >
                            <v-radio
                              value="VISA"
                            >
                              <template v-slot:label>
                                <div class="lbl-radio">VISA</div>
                              </template>
                            </v-radio>
                            <v-radio
                              value="MASTERCARD"
                            >
                              <template v-slot:label>
                                <div class="lbl-radio">MASTERCARD</div>
                              </template>
                            </v-radio>
                          </v-radio-group>

                        </v-col>
                        <v-col
                          md="8"
                          cols="12"
                          class="d-flex flex-column"
                        >
                          <v-text-field
                            id="ccattn"
                            v-model="acctSelectedAccount._ccInfo.acctnumber"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Card Number
                            </template>
                          </v-text-field>
                          <v-select
                            v-model="acctSelectedAccount._ccInfo.ccMonth"
                            :items="optsMonths"
                            :rules="[rules.required]"
                            @change="onCCMonthChanged"
                            label="Expiration Month"
                          ></v-select>
                          <v-select
                            v-model="acctSelectedAccount._ccInfo.ccYear"
                            :items="optsYears"
                            :rules="[rules.required]"
                            @change="onCCYearChanged"
                            label="Expiration Year"
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            id="ccattn"
                            v-model="acctSelectedAccount._ccInfo.attn"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Name on Card
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._ccInfo.addr1"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Address 1
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._ccInfo.city"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              City
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._ccInfo.state"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              State
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._ccInfo.zip"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Zip Code
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  <v-card
                    flat
                    class="px-3 pb-3 mx-3 card-full-width"
                  >
                    <v-alert
                      v-if="acctCCErrors.length > 0"
                      type="error"
                    >
                      <ul>
                        <li
                          v-for="(err, i) in acctCCErrors"
                          :key="i"
                        >
                          {{ err }}
                        </li>
                      </ul>
                    </v-alert>
                  </v-card>
                  <v-card
                    flat
                    class="mx-auto card-full-width"
                  >
                    <v-btn
                      tile
                      block
                      color="primary"
                      @click="doUpdateCreditCard"
                      :loading="acctIsUpdatingPaymentDetails"
                      :disabled="acctIsUpdatingPaymentDetails"
                    >
                      Save Credit Card
                    </v-btn>
                  </v-card>
                </v-row>
              </base-sq-card>

            </v-col>
            <!--                Echeck Details-->
            <v-col
              cols="12"
              md="6"
            >
              <base-sq-card title="Echeck Details">
                <v-row
                  class="mx-2"
                >
                  <v-card
                    flat
                    class="px-3 pb-3 mx-3 card-full-width"
                  >
                    <v-form
                      ref="formEcheck"
                    >
                      <v-radio-group
                        v-model="selectedAccount._echeckInfo.bank_acct_type"
                        :rules="[rules.required]"
                      >
                        <v-radio
                          value="1"
                        >
                          <template v-slot:label>
                            <div class="lbl-radio">Checking</div>
                          </template>
                        </v-radio>
                        <v-radio
                          value="2"
                        >
                          <template v-slot:label>
                            <div class="lbl-radio">Savings</div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                      <v-row>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="selectedAccount._echeckInfo.routenumber"
                            label="Route Number"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Route Number
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="selectedAccount._echeckInfo.acctnumber"
                            label="Account Number"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Account Number
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._echeckInfo.attn"
                            label="Name on Account"
                            :rules="[rules.required]"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._echeckInfo.addr1"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Address 1
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._echeckInfo.city"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              City
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._echeckInfo.state"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              State
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="acctSelectedAccount._echeckInfo.zip"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              Zip Code
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  <v-card
                    flat
                    class="px-3 pb-3 mx-3 card-full-width"
                  >
                    <v-alert
                      v-if="acctEcheckErrors.length > 0"
                      type="error"
                    >
                      <ul>
                        <li
                          v-for="(err, i) in acctEcheckErrors"
                          :key="i"
                        >
                          {{ err }}
                        </li>
                      </ul>
                    </v-alert>
                  </v-card>
                  <v-card
                    flat
                    class="mx-auto card-full-width"
                  >
                    <v-btn
                      tile
                      block
                      color="primary"
                      @click="doUpdateEcheck"
                      :loading="acctIsUpdatingPaymentDetails"
                      :disabled="acctIsUpdatingPaymentDetails"
                    >
                      Save Echeck
                    </v-btn>
                  </v-card>
                </v-row>
                <v-container
                  v-if="selectedAccount._statementMethod === 'EMAIL'"
                >
                  <h1>Email</h1>
                </v-container>
                <v-container
                  v-if="selectedAccount._statementMethod === 'PAPER'"
                >
                  <h1>Paper</h1>
                </v-container>
                <v-overlay :value="acctIsUpdatingPaymentDetails">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  ></v-progress-circular>
                </v-overlay>
              </base-sq-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          key="contact"
        >
          <v-row>
            <v-col>
              <acct-phones></acct-phones>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <acct-addresses></acct-addresses>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          key="payment"
        >
          <pow-account-payment></pow-account-payment>
        </v-tab-item>
        <v-tab-item
          key="activity"
        >
          <v-row>
            <v-col
              cols="12"
            >
              <pow-account-activity></pow-account-activity>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </base-tile-card>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import {
    ACCT_GET_ACCOUNT,
    ACCT_GET_ACCOUNT_INVOICES, ACCT_GET_ACCOUNT_TICKETS, ACCT_GET_ACCOUNT_RATES,
    ACCT_POST_PAYMENT_CC,
    ACCT_POST_PAYMENT_ECHECK,
    ACCT_UPDATE_CREDIT_CARD,
    ACCT_UPDATE_ECHECK,
    ACCT_UPDATE_STMT_METH, _DOWNLOAD_INVOICE, ACCT_GET_ACCOUNT_USERS,
  } from '../../../store/actions.types'
  import {
    ACCT_SET_ERRORS_CC_FORM, ACCT_SET_ERRORS_ECHECK_FORM,
    ACCT_SET_ERRORS_POST_PAYMENT,
    ACCT_UPDATE_SELECTED_ACCOUNT, ACCT_UPDATE_SELECTED_ACCOUNT_KEY,
  } from '../../../store/mutations.types'
  import moment from '../../../assets/js/moment.min'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'AccountDetails',
    components: {
      // PowInvoiceDetails: () => import('@/components/pow/InvoiceDetails'),
      AcctStaffToolbar: () => import('@/components/pow/AccountStaffToolbar'),
      AcctAssignLogin: () => import('@/components/acct/AssignLogin'),
      AcctPhones: () => import('@/components/acct/Phones'),
      AcctAddresses: () => import('@/components/acct/Addresses'),
      AcctPlans: () => import('@/components/acct/Plans'),
      AcctInvoices: () => import('@/components/acct/Invoices'),
      AcctCorrespondences: () => import('@/components/acct/Correspondences'),
      PowAccountGeneral: () => import('@/components/pow/AccountGeneral'),
      // PowAccountCorrespondences: () => import('@/components/pow/AccountCorrespondences'),
      PowAccountPayments: () => import('@/components/pow/AccountPayments'),
      PowAccountTickets: () => import('@/components/pow/AccountTickets'),
      PowAccountForms: () => import('@/components/pow/AccountForms'),
      PowAccountActivity: () => import('@/components/pow/AccountActivity'),
      PowAccountAssignForms: () => import('@/components/pow/AccountAssignForms'),
      PowAccountUsers: () => import('@/components/pow/AccountUsers'),
      // PowAccountCreateInvoice: () => import('@/components/pow/AccountCreateInvoice'),
      PowAccountPayment: () => import('@/components/pow/AccountPayment'),
    },
    mixins: [basicMixin],

    data () {
      return {
        tab: 0,
        confirmPaymentDialog: false,
        paymentSuccessDialog: false,
        dlgAssignForm: false,
        dlgAssignPlan: false,
        dlgEditPlan: false,
        dlgAddLogin: false,
        selectedInvoices: [],
        updateStatementErrors: [],
        urgentInvoices: [],
        totalDue: 0,
        headersUrgentInvoices: [
          {
            text: 'Invoice',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'invoice',
          },
          {
            text: 'Due Date',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'due_formatted',
          },
          {
            text: 'Amt Due',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'due',
          },
          {
            text: 'Status',
            align: 'start',
            sortable: false,
            groupable: false,
            value: 'status',
          },
        ],
        selectedPaymentOption: '',
        statementMethodChanged: false,
        newEcheckInfo: {
          attn: '',
          bank_acct_type: '',
          routenumber: '',
          banknumbermasked: '',
          acctnumber: '',
        },
        newCCInfo: {
          attn: '',
          cctype: '',
          creditcardmasked: '',
          acctnumber: '',
          ccMonth: null,
          ccYear: null,
        },
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          mustAccept: v => v >= 1 || 'Must accept to continue',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
      }
    },
    watch: {
      'urgentInvoices.selected' (val) {
        console.log('Urgent Invoices', val)
        this.markUnpaidInvoice()
      },
      acctSelectedAccount: {
        handler: function (val, oldVal) {
          this.updateSelectedAccount(val)
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters([
        'acctCCErrors', 'acctAccounts', 'acctSelectedAccount', 'acctSelectedAccountUnpaidInvoices',
        'optsMonths', 'optsYears', 'acctIsUpdatingPaymentDetails', 'acctIsGettingAccountInvoices',
        'acctEcheckErrors', 'acctPostPaymentErrors', 'acctIsPostingPayment', 'acctSelectedAccountTickets',
        'acctSelectedAccountRates', 'authIsStaff',
      ]),
      ...mapGetters({
        selectedAccount: 'acctSelectedAccount',
      }),
      isSavedCardValid: function () {
        let validMonth = false
        let validYear = false
        let ccLengthValid = false
        if (this.acctSelectedAccount._ccInfo &&
          this.acctSelectedAccount._ccInfo.acctnumber) {
          ccLengthValid = this.acctSelectedAccount._ccInfo.acctnumber.length > 0
        }
        const now = moment()

        if (this.acctSelectedAccount._ccInfo.ccYear >= now.year()) {
          validYear = true
          if (this.acctSelectedAccount._ccInfo.ccYear === now.year() && this.acctSelectedAccount._ccInfo.ccMonth >= now.month() + 1) {
            validMonth = true
          } else if (this.acctSelectedAccount._ccInfo.ccYear > now.year() && this.acctSelectedAccount._ccInfo.ccMonth > 0) {
            validMonth = true
          }
        }
        if (ccLengthValid && validYear && validMonth && validYear) {
          return true
        }
        console.log(`CClength: ${ccLengthValid}, validYear: ${validYear}, validMonth: ${validMonth}`)
        return false
      },
      isSavedEcheckValid: function () {
        const routenumberLengthValid = this.selectedAccount._echeckInfo.routenumber.length > 0
        const acctnumberLengthValid = this.selectedAccount._echeckInfo.acctnumber.length > 0
        if (routenumberLengthValid && acctnumberLengthValid) {
          return true
        }
        return false
      },
      canMakePayment: function () {
        return (this.selectedPaymentOption !== '' && this.selectedInvoices.length > 0 && this.totalDue > 0)
      },
    },
    async created () {
      // await this.doGetAccounts()
      console.log('page loaded')
      // console.log(this.accounts)
      console.log(this.$route)
      if (this.$route.params.rowkey) {
        // const payload = {
        //   rowkey: this.$route.params.rowkey,
        //   params: this.$route.query,
        // }
        // this.setAccountKey(this.$route.params.rowkey)
        // await this.getAccount(payload)
        // console.log(this.selectedAccount)
      }
    },
    beforeRouteEnter: (to, from, next) => {
      const rowkey = to.params.rowkey
      const payload = {
        rowkey: rowkey,
        params: to.query,
      }
      next((vm) => {
        console.log('pre-loading account before entering route')
        vm.setAccountKey(rowkey)
        try {
          vm.getAccount(payload)
        } catch (e) {
          console.log(e)
        }
      })
    },
    mounted () {
      // const queryParams = this.$route.params
      this.markUnpaidInvoice()
    },
    methods: {
      ...mapActions(['getAccount', 'getUnpaidInvoices', 'getECheckInfo',
                     'getCreditCardInfo']),
      ...mapActions({
        getAccount: ACCT_GET_ACCOUNT,
        getAccountInvoices: ACCT_GET_ACCOUNT_INVOICES,
        getAccountTickets: ACCT_GET_ACCOUNT_TICKETS,
        getAccountRates: ACCT_GET_ACCOUNT_RATES,
        updateStatementMethod: ACCT_UPDATE_STMT_METH,
        updateCreditCard: ACCT_UPDATE_CREDIT_CARD,
        updateEcheck: ACCT_UPDATE_ECHECK,
        postPaymentCC: ACCT_POST_PAYMENT_CC,
        postPaymentEcheck: ACCT_POST_PAYMENT_ECHECK,
        downloadInvoice: _DOWNLOAD_INVOICE,
        getUsers: ACCT_GET_ACCOUNT_USERS,
      }),
      ...mapMutations({
        setAccountKey: ACCT_UPDATE_SELECTED_ACCOUNT_KEY,
        updateSelectedAccount: ACCT_UPDATE_SELECTED_ACCOUNT,
        setPostPaymentErrors: ACCT_SET_ERRORS_POST_PAYMENT,
        setCCFormErrors: ACCT_SET_ERRORS_CC_FORM,
        setEcheckFormErrors: ACCT_SET_ERRORS_ECHECK_FORM,
      }),
      async doGetECheckInfo () {
        try {
          const eCheckInfo = await this.getECheckInfo({ custid: this.selectedAccount.id })
          console.log(eCheckInfo)
        } catch (e) {
          console.log(e)
        }
      },
      async doGetCCInfo () {
        try {
          this.ccInfo = await this.getCreditCardInfo({ custid: this.selectedAccount.id })
          console.log('CreditCard Info:', this.ccInfo)
        } catch (e) {
          console.log(e)
        }
      },
      async doGetUnpaidInvoices () {
        await this.getAccountInvoices({ rowkey: this.selectedAccount.rowkey, unpaid: true })
        this.markUnpaidInvoice()
      },
      async doProcessPayment () {
        console.log('Preparring to processess payment for selected invoices')
        const paymentPaylod = {}
        paymentPaylod.rowkey = this.acctSelectedAccount.rowkey
        let total = 0
        const invoices = []
        if (this.acctSelectedAccountUnpaidInvoices && this.acctSelectedAccountUnpaidInvoices.length > 0) {
          for (const invoice of this.acctSelectedAccountUnpaidInvoices) {
            if (invoice.selected) {
              invoices.push(invoice.invoice)
              total += invoice.due
            }
          }
        }
        console.log('selected invoices for payment:', invoices)
        console.log('selected total for payment:', total)
        paymentPaylod.tender = total
        paymentPaylod.invoices = invoices
        let validForm = false
        switch (this.selectedPaymentOption) {
          case '':
            console.log('payment option must be selected')
            break
          case 'newCC':
            validForm = this.$refs.newCCPayment.validate()
            console.log('New CC option selected')
            paymentPaylod.attn = this.newCCInfo.attn
            paymentPaylod.type = this.newCCInfo.cctype
            paymentPaylod.number = this.newCCInfo.acctnumber
            paymentPaylod.month = this.newCCInfo.ccMonth
            paymentPaylod.year = this.newCCInfo.ccYear
            paymentPaylod.addr1 = this.newCCInfo.addr1
            paymentPaylod.city = this.newCCInfo.city
            paymentPaylod.state = this.newCCInfo.state
            paymentPaylod.zip = this.newCCInfo.zip
            break
          case 'newECheck':
            validForm = this.$refs.newFormEcheck.validate()
            console.log('New Echeck option selected')
            paymentPaylod.attn = this.newEcheckInfo.attn
            paymentPaylod.type = this.newEcheckInfo.bank_acct_type
            paymentPaylod.acct_number = this.newEcheckInfo.acctnumber
            paymentPaylod.route_number = this.newEcheckInfo.routenumber
            paymentPaylod.addr1 = this.newEcheckInfo.addr1
            paymentPaylod.city = this.newEcheckInfo.city
            paymentPaylod.state = this.newEcheckInfo.state
            paymentPaylod.zip = this.newEcheckInfo.zip
            break
          case 'savedCC':
            validForm = this.verifyCreditCardForm()
            console.log('Saved CC option selected')
            paymentPaylod.attn = this.selectedAccount._ccInfo.attn
            paymentPaylod.type = this.selectedAccount._ccInfo.cctype
            paymentPaylod.number = this.selectedAccount._ccInfo.acctnumber
            paymentPaylod.month = this.selectedAccount._ccInfo.ccMonth
            paymentPaylod.year = this.selectedAccount._ccInfo.ccYear
            paymentPaylod.addr1 = this.selectedAccount._ccInfo.addr1
            paymentPaylod.city = this.selectedAccount._ccInfo.city
            paymentPaylod.state = this.selectedAccount._ccInfo.state
            paymentPaylod.zip = this.selectedAccount._ccInfo.zip
            break
          case 'savedECheck':
            validForm = this.verifyEcheckForm()
            console.log('Saved Echeck option selected')
            paymentPaylod.attn = this.selectedAccount._echeckInfo.attn
            paymentPaylod.type = this.selectedAccount._echeckInfo.bank_acct_type
            paymentPaylod.acct_number = this.selectedAccount._echeckInfo.acctnumber
            paymentPaylod.route_number = this.selectedAccount._echeckInfo.routenumber
            paymentPaylod.addr1 = this.selectedAccount._echeckInfo.addr1
            paymentPaylod.city = this.selectedAccount._echeckInfo.city
            paymentPaylod.state = this.selectedAccount._echeckInfo.state
            paymentPaylod.zip = this.selectedAccount._echeckInfo.zip
            break
        }
        console.log('Form valid:', validForm)
        console.log('Payment Payload: ', paymentPaylod)
        if (!validForm) {
          this.setPostPaymentErrors(['Please check required fields.'])
          console.log('Form is not valid, exiting payment')
          return
        }
        let paymentResponse = null
        if (this.selectedPaymentOption === 'newCC' || this.selectedPaymentOption === 'savedCC') {
          paymentResponse = await this.postPaymentCC(paymentPaylod)
        } else if (this.selectedPaymentOption === 'newECheck' || this.selectedPaymentOption === 'savedECheck') {
          paymentResponse = await this.postPaymentEcheck(paymentPaylod)
          // paymentResponse = true
        }
        if (paymentResponse) {
          this.paymentSuccessDialog = true
          this.confirmPaymentDialog = false
          await this.doGetUnpaidInvoices()
        }
        console.log(paymentResponse)
      },
      async verifyCreditCardForm () {
        // const payload = {
        //   rowkey: this.acctSelectedAccount.rowkey,
        //   attn: this.acctSelectedAccount._ccInfo.attn,
        //   type: this.acctSelectedAccount._ccInfo.cctype,
        //   number: this.acctSelectedAccount._ccInfo.acctnumber,
        //   month: this.acctSelectedAccount._ccInfo.ccMonth,
        //   year: this.acctSelectedAccount._ccInfo.ccYear,
        //   addr1: this.acctSelectedAccount._ccInfo.addr1,
        //   city: this.acctSelectedAccount._ccInfo.city,
        //   state: this.acctSelectedAccount._ccInfo.state,
        //   zip: this.acctSelectedAccount._ccInfo.zip,
        // }
        const formIsValid = this.$refs.formCreditCard.validate()
        if (!formIsValid) {
          this.setCCFormErrors(['Please make sure all fields are filled and try again.'])
          return false
        }
        this.setCCFormErrors([])
        console.log('Credit card form is valid: ', formIsValid)
        return formIsValid
      },
      async verifyEcheckForm () {
        const formIsValid = this.$refs.formEcheck.validate()
        if (!formIsValid) {
          this.setEcheckFormErrors(['Please make sure all fields are filled and try again.'])
          return false
        }
        this.setEcheckFormErrors([])
        console.log('Echeck form is valid: ', formIsValid)
        return formIsValid
      },
      async doUpdateCreditCard () {
        const formValid = await this.verifyCreditCardForm()
        if (!formValid) return
        console.log('Updating Credit card information... form valid...', formValid)
        try {
          const payload = {
            rowkey: this.acctSelectedAccount.rowkey,
            attn: this.acctSelectedAccount._ccInfo.attn,
            type: this.acctSelectedAccount._ccInfo.cctype,
            number: this.acctSelectedAccount._ccInfo.acctnumber,
            month: this.acctSelectedAccount._ccInfo.ccMonth,
            year: this.acctSelectedAccount._ccInfo.ccYear,
            addr1: this.acctSelectedAccount._ccInfo.addr1,
            city: this.acctSelectedAccount._ccInfo.city,
            state: this.acctSelectedAccount._ccInfo.state,
            zip: this.acctSelectedAccount._ccInfo.zip,
          }
          const response = await this.updateCreditCard(payload)
          if (response && this.statementMethodChanged) {
            await this.doUpdateStatementMethod()
          }
          console.log(response)
        } catch (e) {
          console.log(e)
        }
      },
      async doUpdateEcheck () {
        const formValid = await this.verifyEcheckForm()
        if (!formValid) return
        console.log('Updating echeck information...')
        try {
          const payload = {
            rowkey: this.acctSelectedAccount.rowkey,
            attn: this.acctSelectedAccount._echeckInfo.attn,
            route_number: this.acctSelectedAccount._echeckInfo.routenumber,
            acct_number: this.acctSelectedAccount._echeckInfo.acctnumber,
            type: this.acctSelectedAccount._echeckInfo.bank_acct_type,
            addr1: this.acctSelectedAccount._echeckInfo.addr1,
            city: this.acctSelectedAccount._echeckInfo.city,
            state: this.acctSelectedAccount._echeckInfo.state,
            zip: this.acctSelectedAccount._echeckInfo.zip,
          }
          const response = await this.updateEcheck(payload)
          if (response && this.statementMethodChanged) {
            await this.doUpdateStatementMethod()
          }
          console.log(response)
        } catch (e) {
          console.log(e)
        }
      },
      markUnpaidInvoice () {
        if (this.acctSelectedAccountUnpaidInvoices && this.acctSelectedAccountUnpaidInvoices.length > 0) {
          for (const invoice of this.acctSelectedAccountUnpaidInvoices) {
            if (invoice.status === 'OVERDUE') {
              this.selectedInvoices.push(invoice.invoice)
              invoice.selected = true
            }
          }
        }
        this.updateTotalDue()
      },
      onInvoiceSelected (event, invoice) {
        if (invoice.status === 'OVERDUE') return
        invoice.selected = !invoice.selected
        this.updateTotalDue()
      },
      async onStatementMethodChange (event) {
        this.statementMethodChanged = true
        console.log(event)
      },
      async doUpdateStatementMethod () {
        let methodValid = false
        this.updateStatementErrors = []
        if (this.selectedAccount._statementMethod === 'CREDIT CARD') {
          methodValid = await this.verifyCreditCardForm()
          console.log('Credit card form valid: ', methodValid)
        }
        if (this.selectedAccount._statementMethod === 'ECHECK') {
          methodValid = await this.verifyEcheckForm()
          console.log('Echeck form valid: ', methodValid)
        }
        if (this.selectedAccount._statementMethod === 'EMAIL') {
          methodValid = true
          console.log('Email form valid: ', methodValid)
        }
        if (!methodValid) {
          console.log(`${this.selectedAccount._statementMethod} form valid: ${methodValid}`)
          this.updateStatementErrors.push('Please fill and/or correct any fields below and try again.')
          return
        }
        const updatedStatement = await this.updateStatementMethod({
          rowkey: this.acctSelectedAccount.rowkey,
          method: this.selectedAccount._statementMethod,
        })
        if (updatedStatement) {
          this.statementMethodChanged = false
        }
      },
      onCCMonthChanged (event) {
        console.log(event)
      },
      onCCYearChanged (event) {
        console.log(event)
      },
      updateTotalDue () {
        console.log('updating total due...')
        let total = 0
        if (this.acctSelectedAccountUnpaidInvoices && this.acctSelectedAccountUnpaidInvoices.length > 0) {
          for (const invoice of this.acctSelectedAccountUnpaidInvoices) {
            if (invoice.selected) {
              total += invoice.due
            }
          }
        }
        this.totalDue = total
        return total
      },

    },
  }
</script>

<style scoped>
  .list-lbl {
    width: 220px;
    font-weight: bold;
  }
</style>
